import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
const CURRENT_YEAR = new Date().getFullYear();
const contactLinks = [{
  icon: '📧',
  label: 'soporteprofepack@gmail.com',
  href: 'mailto:soporteprofepack@gmail.com'
}, {
  icon: '📲',
  label: '@profepack',
  href: 'https://instagram.com/profepack'
}, {
  icon: '🌐',
  label: 'www.profepack.com',
  href: 'https://www.profepack.com'
}];
export function Footer() {
  return <footer className="w-full bg-black border-t border-[#C8962E]/10 py-12 px-4" data-id="element-119">
      <motion.div className="max-w-2xl mx-auto text-center" initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-120">
        <p className="text-[#C8962E]/80 text-xl sm:text-2xl font-black tracking-[0.2em] mb-4" data-id="element-121">
          💃 PROFEPACK™
        </p>
        <p className="text-gray-400 text-sm leading-relaxed mb-3" data-id="element-122">
          El sistema de clases N°1 para profesores de tango en Argentina.
        </p>
        <p className="text-gray-500 text-xs sm:text-sm italic mb-8" data-id="element-123">
          Porque enseñar tango no debería costarte todos los domingos del año.
        </p>

        <nav aria-label="Contacto" className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-5 text-xs sm:text-sm text-gray-400 mb-8" data-id="element-124">
          {contactLinks.map((link, i) => <Fragment key={link.href} data-id="element-125">
              {i > 0 && <span className="hidden sm:inline text-gray-700" aria-hidden="true" data-id="element-126">
                  •
                </span>}
              <a href={link.href} target="_blank" rel="noopener noreferrer" className="hover:text-gray-300 transition-colors" data-id="element-127">
                {link.icon} {link.label}
              </a>
            </Fragment>)}
        </nav>

        <div className="h-px bg-gradient-to-r from-transparent via-[#C8962E]/15 to-transparent mb-6" aria-hidden="true" data-id="element-128" />

        <p className="text-gray-500 text-[10px] sm:text-xs mb-2" data-id="element-129">
          © ProfePack™ {CURRENT_YEAR} — Todos los derechos reservados.
        </p>
        <p className="text-gray-600 text-[10px] sm:text-xs" data-id="element-130">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </motion.div>
    </footer>;
}